import { render } from "./SingleCourseView.vue?vue&type=template&id=7d165568"
import script from "./SingleCourseView.vue?vue&type=script&lang=js"
export * from "./SingleCourseView.vue?vue&type=script&lang=js"

import "./SingleCourseView.vue?vue&type=style&index=0&id=7d165568&lang=css"
import "./SingleCourseView.vue?vue&type=style&index=1&id=7d165568&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__